module.exports = __webpack_public_path__ + "static/media/Cover_Conical.06f14b46.png";